import * as React from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { Link } from "react-router-dom";

const PREFIX = "RouterLink";

const classes = {
  linkStyle: `${PREFIX}-linkStyle`,
};

const StyledLink = styled(Link)(() => ({
  [`& .${classes.linkStyle}`]: {
    "color": "#0033FF",
    "textDecoration": "underline",
    "&:visited": {
      color: "#9900CC",
    },
    "&:focus, &:hover": {
      color: "#BB3300",
    },
    "&:active": {
      color: "#663300",
    },
  },
}));

export interface Props {
  children: React.ReactNode;
  href: string;
  buttonLink?: boolean;
  onClick?: (e: any) => void;
  className?: string;
  from?: string;
  currentUrl?: string;
  id?: string;
}

export default function RouterLink({
  href,
  children,
  buttonLink,
  onClick,
  id,
  currentUrl,
  className,
  from,
}: Props) {
  const splitHref = href.split("?");
  return (
    <StyledLink
      id={id}
      className={clsx(buttonLink ? "" : classes.linkStyle, className)}
      onClick={onClick}
      to={{
        pathname: splitHref[0],
        search: splitHref[1],
        state: { url: currentUrl, from: from },
      }}
    >
      {children}
    </StyledLink>
  );
}
